import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const RectangleOnOff = (props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Auswerten, ob Aktiv
  let simulation = false;

  try {
    simulation = props.style.properties.simulation;
  } catch (error) {
    simulation = false;
  }

  let isActive;
  if (value.value === "1" || simulation) {
    isActive = true;
  } else {
    isActive = false;
  }

  //========================================================================
  //
  let borderWidth;
  if (props.style.borderWidth === "NaNpx") {
    borderWidth = "0px";
  } else {
    borderWidth = props.style.borderWidth;
  }
  const left = `calc(${props.style.left} - ${borderWidth})`;
  const top = `calc(${props.style.top} - ${borderWidth})`;
  const right = `calc(${props.style.right} - ${borderWidth})`;
  const bottom = `calc(${props.style.bottom} - ${borderWidth})`;

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        backgroundColor: isActive
          ? props.element.activeColor
          : props.style.backgroundColor || "#333",
        visibility: props.props.visibility,
        position: "absolute",
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        borderWidth: borderWidth,
      }}
    ></div>
  );
};

export default RectangleOnOff;
